import { __assign } from "tslib";
import { OutputLocation } from "./models_0";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
export var RestoreRequestType;

(function (RestoreRequestType) {
  RestoreRequestType["SELECT"] = "SELECT";
})(RestoreRequestType || (RestoreRequestType = {}));

export var RestoreRequest;

(function (RestoreRequest) {
  RestoreRequest.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.OutputLocation && {
      OutputLocation: OutputLocation.filterSensitiveLog(obj.OutputLocation)
    });
  };
})(RestoreRequest || (RestoreRequest = {}));

export var RestoreObjectRequest;

(function (RestoreObjectRequest) {
  RestoreObjectRequest.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.RestoreRequest && {
      RestoreRequest: RestoreRequest.filterSensitiveLog(obj.RestoreRequest)
    });
  };
})(RestoreObjectRequest || (RestoreObjectRequest = {}));

export var ContinuationEvent;

(function (ContinuationEvent) {
  ContinuationEvent.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(ContinuationEvent || (ContinuationEvent = {}));

export var EndEvent;

(function (EndEvent) {
  EndEvent.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(EndEvent || (EndEvent = {}));

export var Progress;

(function (Progress) {
  Progress.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(Progress || (Progress = {}));

export var ProgressEvent;

(function (ProgressEvent) {
  ProgressEvent.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(ProgressEvent || (ProgressEvent = {}));

export var RecordsEvent;

(function (RecordsEvent) {
  RecordsEvent.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(RecordsEvent || (RecordsEvent = {}));

export var Stats;

(function (Stats) {
  Stats.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(Stats || (Stats = {}));

export var StatsEvent;

(function (StatsEvent) {
  StatsEvent.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(StatsEvent || (StatsEvent = {}));

export var SelectObjectContentEventStream;

(function (SelectObjectContentEventStream) {
  SelectObjectContentEventStream.visit = function (value, visitor) {
    if (value.Cont !== undefined) return visitor.Cont(value.Cont);
    if (value.Progress !== undefined) return visitor.Progress(value.Progress);
    if (value.Stats !== undefined) return visitor.Stats(value.Stats);
    if (value.End !== undefined) return visitor.End(value.End);
    if (value.Records !== undefined) return visitor.Records(value.Records);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };

  SelectObjectContentEventStream.filterSensitiveLog = function (obj) {
    var _a;

    if (obj.Cont !== undefined) return {
      Cont: ContinuationEvent.filterSensitiveLog(obj.Cont)
    };
    if (obj.Progress !== undefined) return {
      Progress: ProgressEvent.filterSensitiveLog(obj.Progress)
    };
    if (obj.Stats !== undefined) return {
      Stats: StatsEvent.filterSensitiveLog(obj.Stats)
    };
    if (obj.End !== undefined) return {
      End: EndEvent.filterSensitiveLog(obj.End)
    };
    if (obj.Records !== undefined) return {
      Records: RecordsEvent.filterSensitiveLog(obj.Records)
    };
    if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
  };
})(SelectObjectContentEventStream || (SelectObjectContentEventStream = {}));

export var SelectObjectContentOutput;

(function (SelectObjectContentOutput) {
  SelectObjectContentOutput.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.Payload && {
      Payload: "STREAMING_CONTENT"
    });
  };
})(SelectObjectContentOutput || (SelectObjectContentOutput = {}));

export var RequestProgress;

(function (RequestProgress) {
  RequestProgress.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(RequestProgress || (RequestProgress = {}));

export var ScanRange;

(function (ScanRange) {
  ScanRange.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(ScanRange || (ScanRange = {}));

export var SelectObjectContentRequest;

(function (SelectObjectContentRequest) {
  SelectObjectContentRequest.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.SSECustomerKey && {
      SSECustomerKey: SENSITIVE_STRING
    });
  };
})(SelectObjectContentRequest || (SelectObjectContentRequest = {}));

export var UploadPartOutput;

(function (UploadPartOutput) {
  UploadPartOutput.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.SSEKMSKeyId && {
      SSEKMSKeyId: SENSITIVE_STRING
    });
  };
})(UploadPartOutput || (UploadPartOutput = {}));

export var UploadPartRequest;

(function (UploadPartRequest) {
  UploadPartRequest.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.SSECustomerKey && {
      SSECustomerKey: SENSITIVE_STRING
    });
  };
})(UploadPartRequest || (UploadPartRequest = {}));

export var CopyPartResult;

(function (CopyPartResult) {
  CopyPartResult.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(CopyPartResult || (CopyPartResult = {}));

export var UploadPartCopyOutput;

(function (UploadPartCopyOutput) {
  UploadPartCopyOutput.filterSensitiveLog = function (obj) {
    return __assign(__assign({}, obj), obj.SSEKMSKeyId && {
      SSEKMSKeyId: SENSITIVE_STRING
    });
  };
})(UploadPartCopyOutput || (UploadPartCopyOutput = {}));

export var UploadPartCopyRequest;

(function (UploadPartCopyRequest) {
  UploadPartCopyRequest.filterSensitiveLog = function (obj) {
    return __assign(__assign(__assign({}, obj), obj.SSECustomerKey && {
      SSECustomerKey: SENSITIVE_STRING
    }), obj.CopySourceSSECustomerKey && {
      CopySourceSSECustomerKey: SENSITIVE_STRING
    });
  };
})(UploadPartCopyRequest || (UploadPartCopyRequest = {}));